export default __webpack_public_path__ + "static/silverXsDetail-2de919a7d3f3922053fc3eac5257df3c.png";